module.exports = __webpack_public_path__ + "static/img/FMZ.98c88b3c.png";